import { render, staticRenderFns } from "./DataCenterTableMicro.vue?vue&type=template&id=3c5d29c0&scoped=true"
import script from "./DataCenterTableMicro.vue?vue&type=script&lang=js"
export * from "./DataCenterTableMicro.vue?vue&type=script&lang=js"
import style0 from "./DataCenterTableMicro.vue?vue&type=style&index=0&id=3c5d29c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d29c0",
  null
  
)

export default component.exports